import React, { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import userIcon from '../../../image/user.png';

// Utility function to convert image URL to Base64
const getBase64Image = async (url) => {
  try {
    const response = await fetch(url, { mode: 'cors' });
    if (!response.ok) throw new Error('Failed to fetch image');
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error fetching image:', error);
    return null; // Return null to trigger fallback
  }
};
const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short'
  };

  let formatted = date.toLocaleString('en-IN', options);

  // Force am/pm to uppercase
  formatted = formatted.replace(/\b(am|pm)\b/i, (match) => match.toUpperCase());

  return formatted;
};



const PDFContent = ({ attempt, assessment, renderHTML, formatDuration, formatDurationsec }) => {
  const [profilePicBase64, setProfilePicBase64] = useState(null);

  // Preload profile picture as Base64
  useEffect(() => {
    const loadImage = async () => {
      if (attempt.profilePic && attempt.profilePic !== '') {
        const base64 = await getBase64Image(attempt.profilePic);
        setProfilePicBase64(base64 || userIcon); // Fallback to default icon
      } else {
        setProfilePicBase64(userIcon);
      }
    };
    loadImage();
  }, [attempt.profilePic]);

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', backgroundColor: '#fff' }}>
        <div style={{ height: '842pt', pageBreakAfter: 'always' }} className='keep-together'>
            <div className='mb-3'>
              <h1 style={{ fontSize: '30px' }}>Test Taker Details</h1>
            </div>
            <p className='mb-4' style={{ borderBottom: '2px solid #ccc', width: '100%', margin: 0 }}></p>

            <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent:'space-between' }}>
                    <button
                      style={{
                         backgroundColor: '#22c55e', // Tailwind green-500
                          color: '#fff',
                          fontSize: '24px',
                          padding: '8px 16px',
                          border: 'none',
                          borderRadius: '9999px', // pill shape
                          cursor: 'default',

                          fontWeight: '600',
                          // transition: 'transform 0.2s',
                      }}
                    
                    >
                      Score: {attempt.score}/{attempt.totalQuestions}
                    </button>
                    <p className="text-lg font-montserrat font-semibold text-red-500">
                        Test Finish Time: {formatDateTime(attempt.submittedAt)}
                      </p>
            
            </div>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}> */}
            <div className='mb-4' style={{border:'1px solid'}}>
              <div className="flex items-center bg-gray-50" style={{borderBottom:'1px solid'}} >
                <div className='p-4 flex items-center col-12 '>
                  <div className='col-md-1 justify-center flex items-center'>
                      <img
                              src={profilePicBase64 || userIcon}
                          alt="User Icon"
                          className="w-14 h-14 mr-2 rounded-full object-cover"
                          onError={(e) => {
                          e.target.src = userIcon; // Fallback to default icon on error
                          }}
                      />
                  </div>
                  <div className='col-md-11 justify-start grid items-center'>
                      <div className=''>
                          <h3 className="text-xl font-montserrat font-semibold text-black">
                              {(attempt.userName || '') + ' ' + (attempt.lastName || '')}
                          </h3>
                      </div>
                      <div className=' '>
                            <p className='text-xl font-montserrat font-semibold text-black'> Email id : {attempt.email} </p>
                      </div>
                  </div>
                </div>    
              </div>
              <div className='p-3'>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                              <div className="flex ">
                                <h4 className="text-sm font-semibold text-gray-900 mb-2">Difficulty Level:</h4>
                                <p className="text-sm text-gray-600">{assessment.difficultyLevel || 'N/A'}</p>
                              </div>
                              <div className="flex ">
                                <h4 className="text-sm font-semibold text-gray-900 mb-2">Assessment Type:</h4>
                                <p className="text-sm text-gray-600">{assessment.assessmentType || 'N/A'}</p>
                              </div>
                              <div className="flex ">
                                <h4 className="text-sm font-semibold text-gray-900 mb-2">Total Time Duration:</h4>
                                <p className="text-sm text-gray-600">{formatDuration(assessment.duration) || 'N/A'}</p>
                              </div>
                              <div className="flex ">
                                <h4 className="text-sm font-semibold text-gray-900 mb-2">Attempt Time Duration:</h4>
                                <p className="text-sm text-gray-600">{formatDurationsec(attempt.timeDuration) || 'N/A'}</p>
                              </div>
                            </div>
              </div>
            </div> 
            <div style={{ marginBottom: '16px' }}>
              <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>
                Description:
              </h4>
              <div
                style={{ fontSize: '14px', color: '#000' }}
                dangerouslySetInnerHTML={
                  assessment.description
                    ? renderHTML(assessment.description)
                    : { __html: '<p>No description provided.</p>' }
                }
              />
            </div>
       </div>
          <div className='mb-2'>
              <h1 style={{ fontSize: '30px' }}>Candidate Response</h1>
         </div>
            <p className='mb-2' style={{ borderBottom: '2px solid #ccc', width: '100%', margin: 0 }}></p>
           <div style={{ marginTop: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>

        {attempt.answers.map((ans, idx) => {
          const userSelected = ans.selectedOptions || [];
          const correctAnswers = ans.question.correctAnswers || [];
          const hasCorrectAnswers = correctAnswers.length > 0;
          const options = ans.question.options || [];
          const isCodingQuestion = ans.question.type === 'coding';

          return (
            <div
              key={idx}
              className="keep-together"
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '16px',
                backgroundColor: '#f9fafb',
              }}
            >
              <p
                style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '12px',
                  fontFamily: 'Montserrat, sans-serif',
                }}
              >
                Question {idx + 1}: {isCodingQuestion ? ans.question.codingText || 'Coding Question' : ans.question.questionText || 'Question Text Unavailable'}
              </p>
              {isCodingQuestion ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div>
                    <p
                      style={{
                        fontSize: '14px',
                        color: '#4b5563',
                        marginBottom: '4px',
                        fontFamily: 'Montserrat, sans-serif',
                      }}
                    >
                      Language: {ans.language || 'N/A'} ({ans.version || 'N/A'})
                    </p>
                  </div>
                  <div>
                    <p
                      style={{
                        fontSize: '14px',
                        color: '#4b5563',
                        marginBottom: '4px',
                        fontFamily: 'Montserrat, sans-serif',
                      }}
                    >
                      Submitted Code:
                    </p>
                    <pre
                      style={{
                        backgroundColor: '#1f2937',
                        color: '#e5e7eb',
                        padding: '16px',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'monospace',
                        overflow: 'auto',
                        maxHeight: '240px',
                      }}
                    >
                      {ans.code || 'No code submitted'}
                    </pre>
                  </div>
                  <div>
                    <p
                      style={{
                        fontSize: '14px',
                        color: '#4b5563',
                        marginBottom: '4px',
                        fontFamily: 'Montserrat, sans-serif',
                      }}
                    >
                      Output:
                    </p>
                    <pre
                      style={{
                        backgroundColor: '#1f2937',
                        color: '#e5e7eb',
                        padding: '16px',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'monospace',
                        overflow: 'auto',
                        maxHeight: '240px',
                      }}
                    >
                      {ans.output || 'No output generated'}
                    </pre>
                  </div>
                </div>
              ) : (
                <>
                  {!hasCorrectAnswers && (
                    <p
                      style={{
                        fontSize: '14px',
                        color: '#ef4444',
                        marginBottom: '8px',
                        fontFamily: 'Montserrat, sans-serif',
                      }}
                    >
                      Correct answers not available for this question.
                    </p>
                  )}
                  {options.length === 0 && (
                    <p
                      style={{
                        fontSize: '14px',
                        color: '#ef4444',
                        marginBottom: '8px',
                        fontFamily: 'Montserrat, sans-serif',
                      }}
                    >
                      Options not available for this question.
                    </p>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {options.map((option, optIdx) => {
                      const isSelected = userSelected.includes(optIdx);
                      const isCorrect = correctAnswers.includes(optIdx);
                      return (
                        <div
                          key={optIdx}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '12px',
                            borderRadius: '8px',
                            border: `1px solid ${
                              isCorrect && hasCorrectAnswers
                                ? '#86efac'
                                : isSelected && hasCorrectAnswers
                                ? '#fca5a5'
                                : '#e5e7eb'
                            }`,
                            backgroundColor: isCorrect && hasCorrectAnswers
                              ? '#f0f9ff'
                              : isSelected && hasCorrectAnswers
                              ? '#fef2f2'
                              : '#ffffff',
                          }}
                        >
                          <input
                            type={ans.question.type === 'single' ? 'radio' : 'checkbox'}
                            checked={isSelected}
                            disabled
                            style={{
                              height: '20px',
                              width: '20px',
                              accentColor: '#2563eb',
                            }}
                          />
                          <span
                            style={{
                              color: '#374151',
                              fontFamily: 'Montserrat, sans-serif',
                              flexGrow: 1,
                            }}
                          >
                            {option}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PDFContent;